const Profile = {

    // FIELDS
    "other_details": "अन्य विवरण",
    "documents": "दस्तावेज़",
    "update_profile": "प्रोफ़ाइल अपडेट करें",
    "alternate_phone": "वैकल्पिक फोन",
    "emergency_phone": "आपातकालीन फोन",
    "emergency_phone_relative": "आपातकालीन फोन (रिश्तेदार)",
    "blood_group": "रक्त समूह",
    'shoe_size': 'जूते का आकार',
    'tshirt_size': 'टी-शर्ट का आकार',
    "aadhar": "आधार",
    "pan": "पैन",
    "gst": "जीएसटी",
    "view_aadhar": "आधार दस्तावेज़ देखें",
    "view_pan": "पैन दस्तावेज़ देखें",
    "view_gst": "जीएसटी दस्तावेज़ देखें",
    "search": "यहाँ खोजें...",

    "buddies": "साथी",
    "followers": "अनुयायी",
    "folllowing": "अनुसरण कर रहे हैं",
    "unfollow": "अनफ़ॉलो करें",
    "fitness": "फिटनेस",
    "steps": "कदम",
    "distance": "दूरी (मीटर)",
    "last_sync": "आखिरी सिंक",

    // TOAST
    "success_unfollow": "सफलतापूर्वक अनफ़ॉलो किया गया!!..",
    "wrong": "कुछ गलत हो गया!!..",

    // TOAST
    "success_add": "प्रोफ़ाइल सफलतापूर्वक अपडेट की गई!!..",
    "server_error": "सर्वर त्रुटि!!..",
    "wrong": "कुछ गलत हो गया!!..",

}

export default Profile;